<div mat-dialog-title class="large-container">
  <h1>{{ 'ALERTDIALOGTITLE' | translate}}</h1>
  <button mat-button class="close gl-Taxlot_Close" [mat-dialog-close]="true">
    <mat-icon fontSet="fas" fontIcon="fa-times" (click)="onClose()"></mat-icon>
  </button>
</div>
<div mat-dialog-content class="large-container margin-bottom-20">
  <h1 class="col-xs-12 margin-bottom-20">{{ 'ALERTHEADING' | translate}}</h1>
  <p class="col-xs-12 margin-bottom-10 margin-top-10">{{ 'IUNDERSTANDRECEIVEALERTS' | translate}}</p>
  <p class="col-xs-12 margin-bottom-10 margin-top-10">{{ 'IUNDERSTANDACCOUNTSALERTS' | translate}}</p>
</div>
<div mat-dialog-actions class="large-container right">
  <button class="mat-raised-button mat-button-base mat-primary margin-right-10" (click)="onMarketAlertsAgree()"
    [disabled]="isAgreeDisabled">{{ 'AWRAGREE' | translate}}</button>
  <button class="mat-stroked-button mat-button-base mat-primary " (click)="onClose()">{{ 'CANCEL' |
    translate}}</button>
</div>